import { render, staticRenderFns } from "./DietsTable.vue?vue&type=template&id=4219fbe5&scoped=true&"
import script from "./DietsTable.vue?vue&type=script&lang=js&"
export * from "./DietsTable.vue?vue&type=script&lang=js&"
import style0 from "./DietsTable.vue?vue&type=style&index=0&id=4219fbe5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4219fbe5",
  null
  
)

export default component.exports